module.exports = __webpack_public_path__ + "img/01.sun-light.88ac3de4.svg";